export default "__VITE_ASSET__Dm26mjg9__"